(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row-meta"] && !Shopify.designMode) return;
  try {
    function hideEmptyAccordions() {
    document
      .querySelectorAll('accordion-custom[data-hide-if-empty="true"]')
      .forEach((accordion) => {
        // Avoid re-processing the same accordion twice
        if (accordion.dataset.emptyChecked === 'true') return;

        const content = accordion.querySelector('.details-content');
        const details = accordion.querySelector('.details');
        if (!content || !details) return;

        const hasText = content.textContent.trim().length > 0;
        const hasMedia = content.querySelector('img, svg, video, iframe, picture, source');

        if (!hasText && !hasMedia) {
          details.style.display = 'none';
        }

        // Marks as checked so the CSS visibility rule above reveals it (if not empty)
        accordion.dataset.emptyChecked = 'true';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyAccordions);
  } else {
    hideEmptyAccordions();
  }

  // Re-check when the theme editor re-renders this section
  document.addEventListener('shopify:section:load', hideEmptyAccordions);
  } catch(e) { console.error(e); }
})();

})();
